<template>
	<v-col>
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold cl-agen-dark">Bonus Claim</div>
		</div>
		<div class="mt-2">
			<div class="d-flex flex-wrap justify-space-between align-center" v-if="Object.keys(summaryKomisi).length > 0">
				<v-col cols="12" sm="6" md="4" lg="4" xl="3" class="px-0">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow cyan darken-1">
						<v-row>
							<v-col cols="2" sm="2" md="2" class="pr-0 my-auto text-center">
								<img class="img-fluid filter-white" src="/assets/icon/saldo.png">
							</v-col>
							<v-col cols="7" sm="6" md="6">
								<div class="font-size-12 white--text font-weight-bold">{{ summaryKomisi.total_balance  | toCurrencyFormat }}</div>
								<div class="font-size-10 cl-white">Total Your Bonus</div>
							</v-col>
							<v-col cols="3" sm="4" md="4" class="px-0 px-sm-3 text-sm-right my-auto">
								<v-btn depressed color="white darken-1" class="cyan--text text--darken-1 rounded-xl text-capitalize font-weight-bold" @click="showModalKlaim">Claim</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
				<v-col cols="12" sm="6" md="6" lg="6" class="pr-0 pb-0 pb-sm-3">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="amber accent-3" class="white--text rounded-xl text-capitalize" @click="showSearch">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Search</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</div>
			<div class="pt-3" v-if="!loading">
				<v-row v-if="listHistoryKomisi.length > 0">
					<v-col cols="12" class="pt-0">
						<v-simple-table class="white-row table-vo table-vo-small table-history-transfer">
							<template v-slot:default>
								<thead class="">
									<tr>
										<th class="text-left" width="30%">Date</th>
										<th class="text-center" width="20%">Type</th>
										<th class="text-left" width="20%">Info</th>
										<th class="text-right" width="30%">Amount (RM)</th>
									</tr>
								</thead>
								<tbody class="grey--text text--darken-3">
									<tr v-for="komisi in listHistoryKomisi" :key="komisi.bonus_log_id">
										<td class="text-left">{{ komisi.bonus_log_datetime | tanggaljam }}</td>
										<td class="text-center">
											<v-chip :color="(komisi.bonus_log_type == 'in') ? 'teal lighten-2' : 'red lighten-2'" class="white--text font-weight-600" small>
												{{ (komisi.bonus_log_type == 'in') ? 'In' : 'Out' }}
											</v-chip>
										</td>
										<td class="text-left capitalize--text">{{ komisi.bonus_log_name == 'withdraw' ? 'Klaim komisi' : komisi.bonus_log_name }}</td>
										<td>
											<div class="text-right teal--text text--lighten-2 font-weight-600" v-if="komisi.bonus_log_type == 'in'">{{ komisi.bonus_log_value | toNumber }}</div>
											<div class="text-right red--text text--lighten-2 font-weight-600" v-else>{{ komisi.bonus_log_value | toNumber }}</div>
										</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
				<div class="pt-3" v-if="listHistoryKomisi.length == 0">
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-card class="py-3 elevation-0 hover-shadow rounded-lg">
								<NoData></NoData>
								<div class="pt-3 text-center amber--text text--darken-3">No bonus claim data available.</div>
							</v-card>
						</v-col>
					</v-row>
				</div>
				<div v-if="listHistoryKomisi.length > 0">
					<v-row justify="end">
						<v-col cols="12" sm="5" md="6" class="pl-1 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
							<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="amber accent-3" :length="historyKomisiPagination.total_page" @input="changePage"></v-pagination>
						</v-col>
						<v-col cols="12" sm="5" md="5" class="pb-0 pb-sm-3 my-auto text-right">
							<div class=" font-size-10">Showing {{ historyKomisiPagination.total_display }} data from {{ historyKomisiPagination.total_data }} data</div>
						</v-col>
						<v-col cols="3" sm="2" md="1">
							<v-select :items="listLimit" v-model="limit" hide-details dense class="" placeholder="Data" color="amber accent-3" item-color="amber accent-3" @input="changeLimit"></v-select>
						</v-col>
					</v-row>
				</div>
			</div>
			<div class="pt-3" v-if="loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<LoadDataAgen :loading="loading"></LoadDataAgen>
					</v-col>
				</v-row>
			</div>
		</div>
		<ModalCari ref="modalCari" @action="cari"></ModalCari>
		<ModalKlaim ref="modalKlaim" @action="claim"></ModalKlaim>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalCari from './components/ModalCari';
import ModalKlaim from './components/ModalKlaim';

export default {
	components: {
		ModalCari, ModalKlaim
	},
	data() {
		return {
			loading: false,
			startDate: false,
			dateStart: '',
			page: 1,
			limit: '10',
			listLimit: [ '10', '20', '50', '100' ],
			params: [],
		}
	},
	computed: {
		...mapState('komisiAgen', [ 'listHistoryKomisi', 'historyKomisiPagination', 'summaryKomisi']),
	},
	methods: {
		...mapActions('komisiAgen', ['getHistoryKomisi', 'getSummaryKomisi', 'claimKomisi']),
		// ...mapActions('notification', ['changeStatusNotification']),

		async getData() {
			this.loading = await true

      await this.getSummaryKomisi()
			
      await this.getHistoryKomisi(this.queryString({sort: 'bonus_log_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        this.loading = false
      })
		},
		changePage(page) {
			this.page = page
			this.getData()
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getData()
		},
		showSearch() {
			this.$refs.modalCari.modalShow()
		},
		reset() {
			this.page = 1
			this.limit = '10'
			this.params = []
			this.getData()
			this.$refs.modalCari.reset()
		},
		cari(data) {
			this.params = []
			this.params.push(data.type)
			this.getHistoryKomisi(this.queryString({sort: 'bonus_log_datetime', dir: 'DESC', limit:this.limit, page: this.page, params: this.params})).then(() => {
				this.$refs.modalCari.modalHide()
			})
		},
		showModalKlaim() {
			this.$refs.modalKlaim.modalShow()
		},
		claim(val) {
			this.$refs.modalKlaim.loadingButton()
			this.claimKomisi({value: val}).then(()=> {
				this.$refs.modalKlaim.modalHide()
				// this.changeStatusNotification()
				this.getData()
			}).catch(()=> {
				this.$refs.modalKlaim.normalButton()
			})
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Bonus Claim`)
		this.getData()
	}
};
</script>